'use client'

import { BigcategoryList } from '@/app/ui/parts/default/sp/modal/bigCategoryList'
import { ModalSearchBox2 } from '@/app/ui/parts/default/sp/modalSearch2'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTrigger,
} from '@/components/ui/dialog'
import { bigcategoryType } from '@/lib/bigcategory/server'
import { serviceType } from '@/lib/service/server'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { ModalSearchBox } from './modalSearch'

export function TopModalWithBigcategories({
  service,
  text,
  icon = false,
  bigcategories,
}: {
  service: serviceType
  bigcategories: bigcategoryType[]
  text?: string
  icon?: boolean
}) {
  const [open, setOpen] = useState(false)
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        asChild
        onClick={() => {
          setOpen(!open)
        }}
        className="cursor-pointer"
      >
        {icon ? (
          <div className="header-modal-icon w-[20px] mx-2">
            <FontAwesomeIcon icon={faSearch} fontSize={20} />
          </div>
        ) : (
          <div className="relative flex items-center">
            <p className="header-modal-text text-sm font-semibold">
              {text ? text : '商品を検索'}
            </p>
            <div className="header-modal-icon ml-2 lg:hidden">
              <FontAwesomeIcon icon={faSearch} className="text-base" />
            </div>
          </div>
        )}
      </DialogTrigger>
      <DialogContent
        className="p-3.5 border-0 bg-white w-11/12 rounded-md duration-500"
        onOpenAutoFocus={(e) => e.preventDefault()}
        style={{
          maxHeight: '80vh',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <DialogHeader className="mt-4">
          {service.service_id === 'pants-set' ? (
            <ModalSearchBox2 />
          ) : (
            <ModalSearchBox />
          )}
        </DialogHeader>
        <BigcategoryList
          service={service}
          bigcategories={bigcategories}
          open={open}
          setOpen={setOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
